import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal, Space, Switch, Tooltip, message } from 'antd';
import { ConfirmAction } from '../../../molecules/confirm/ConfirmAction';
import { PRODUCT } from '../../../../constants/define/translation';
import { postLoginRepository } from '../../../../repository/mytm/auth/loginRepository';
import { UserContext } from '../../../../repository/context/userContext';
import { MESSAGE_ERROR } from '../../../../constants/message';
import { btnActive } from '../../../../styles';
import {
  postUpdateProductRepository,
  ProductOrders,
} from '../../../../repository/mytm/shop-product/shopProductRepository';

interface ActionsColumnProps {
  record: ProductOrders;
  onRefresh: () => void;
}

export default React.memo((props: ActionsColumnProps) => {
  const { t } = useTranslation(PRODUCT);
  const { record, onRefresh } = props;
  const userContext = useContext(UserContext);

  const [soldOutLoading, setSoldOutLoading] = useState(false);

  const onUpdateSoldOut = () => {
    const payload = { productId: record.product_id, soldOut: !record.sold_out, country: record?.country };
    Modal.confirm({
      title: t('popup.title'),
      okText: t('popup.okBtn'),
      cancelText: t('popup.cancelBtn'),
      icon: <ExclamationCircleOutlined />,
      content: record.sold_out ? (
        <ConfirmAction
          textConfirmAction={t('popup.removeSoldOut')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ) : (
        <ConfirmAction
          textConfirmAction={t('popup.soldOut')}
          isConfirmPassword
          textConfirmPassword={t('popup.confirmPassword')}
        />
      ),
      onOk() {
        setSoldOutLoading(true);
        const inputPasswordNode = document.getElementById('inputPasswordForConfirm');
        const password = (inputPasswordNode as any).value;
        const updateFunc = () => {
          postUpdateProductRepository(record.id, payload)
            .then(r => {
              onRefresh();
              setSoldOutLoading(false);
              message.success(t('message.updateSoldOutProductSuccess'));
            })
            .catch(e => {
              setSoldOutLoading(false);
              message.error(e?.errorMessage || t('message.updateSoldOutProductError'));
            });
        };

        if (!userContext.user?.email || userContext.user?.email === '') {
          setSoldOutLoading(false);
          message.error(MESSAGE_ERROR.M02);
        } else {
          postLoginRepository({
            email: userContext.user?.email,
            password,
          })
            .then(() => {
              updateFunc();
            })
            .catch((e: any) => {
              setSoldOutLoading(false);
              message.error(e?.errorMessage || t('message.updateSoldOutProductError'));
            });
        }
      },
    });
  };

  return (
    <StyledContainer>
      <Space size="small">
        <Tooltip title={record.sold_out ? t('table.tooltip.normal') : t('table.tooltip.soldOut')}>
          <Switch
            checked={!!record.sold_out}
            onChange={onUpdateSoldOut}
            disabled={soldOutLoading}
            loading={soldOutLoading}
          />
        </Tooltip>
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  ${btnActive}
`;
